export const CLOSURES_COLOR = '#EB0087';
export const OPENINGS_COLOR = '#00E1AF';
export const TOTAL_ACTIVE_COLOR = '#999999';
// Bars use Figma's neutral gray (ui-gray/300) at reduced opacity so they sit behind the
// trend lines; the legend dot / tooltip swatch reuse the same gray.
export const BAR_COLOR = '#999999';
export const BAR_FILL_OPACITY = 0.5;
